import React from "react";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import style from "./tabs/ActionsTab.module.scss";

const TenderClosedCard = ({ assignmentMethod = "Tender" }) => {
  const { t } = useTranslation();
  const showClosedTitle = assignmentMethod === "Auction" || assignmentMethod === "Tender";

  return (
    <div className={style.info_card}>
      <div className={cn(style.info_icon_circle, style.info_icon_error)}>
        <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M15 27V19C15 11.82 20.82 6 28 6C35.18 6 41 11.82 41 19V27"
            stroke="white"
            strokeWidth="3.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect x="10" y="27" width="36" height="24" rx="6" fill="white" />
          <circle cx="28" cy="39" r="4" fill="#0d3b66" />
          <path d="M28 43V47" stroke="#0d3b66" strokeWidth="3" strokeLinecap="round" />
        </svg>
      </div>
      <div className={style.info_text_group}>
        {showClosedTitle && (
          <span className={style.info_title_error}>
            {t(assignmentMethod === "Auction" ? "orderInfo.auctionClosed" : "orderInfo.tenderClosed")}
          </span>
        )}
        <span className={style.info_subtitle}>{t("orderInfo.orderNotAvailable")}</span>
      </div>
    </div>
  );
};

export default TenderClosedCard;
